import React, { useState } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CssKpiSvg from '../../assets/icons/KpiSvg';
import CssHelpSvg from '../../assets/icons/HelpSvg';
import CssPullChordSvg from '../../assets/icons/PullChordSvg';
import { DARK_MODE } from '../../constants';
import { pxToRem, responsiveFontSizes } from '../../utils/getFontValue';
import CssBarcodeSvg from '../../assets/icons/BarCodeIcon';
import ReprintBarcodeModal from '../ReprintBarcodeModal/ReprintBarcodeModal';
import RepunchModal from '../RePunchModal/RePunchModal';
import CssRepunchSvg from '../../assets/icons/RepunchIcon';
import ReengraveModal from '../ReEngraveModal.js/ReEngraveModal';
import CssReEngraveSvg from '../../assets/icons/ReEngraveIcon';

const Sidebar = () => {
	const Item = styled(Paper)(({ theme }) => ({
		...theme.typography.body2,
		padding: theme.spacing(1.3),
		width: 'auto',
		textAlign: 'center',
		color: theme.palette.text.secondary,
		backgroundColor: theme.palette.mode === DARK_MODE ? '#000' : '#fff',
	}));

	const CssTypography = styled(Typography)({
		fontWeight: 600,
		fontSize: pxToRem(11),
		...responsiveFontSizes({ sm: 11, md: 12, lg: 14 }),
	});	

	const [isReprintModalOpen, setIsReprintModalOpen] = useState(false);
	const [isRepunchModalOpen, setIsRepunchModalOpen] = useState(false);
	const [isReengraveModalOpen, setIsReengraveModalOpen] = useState(false);


	return (
		<Grid
			container
			direction="column"
			justifyContent="space-between"
			sx={{ height: '100%', p: 2, my: 0.5 }}
		>
			<Grid item>
				<Grid container direction="column">
					<Grid item>
						<Item elevation={3}>
							<CssKpiSvg />
							<CssTypography>View KPIs</CssTypography>
						</Item>
					</Grid>
					<Grid item marginTop={4}>
						<Item elevation={3}>
							<CssPullChordSvg />
							<CssTypography>Pull Chord</CssTypography>
						</Item>
					</Grid>
					<Grid item marginTop={4}>
						<Item elevation={3}>
							<CssHelpSvg />
							<CssTypography>Help</CssTypography>
						</Item>
					</Grid>
					<Grid
						item
						marginTop={4}
						style={{ cursor: 'pointer' }}
						onClick={() => setIsReprintModalOpen(true)}
					>
						<Item elevation={3}>
							<CssBarcodeSvg />
							<CssTypography>Reprint Barcode</CssTypography>
						</Item>
					</Grid>
					<Grid
						item
						marginTop={4}
						style={{ cursor: 'pointer' }}
						onClick={() => setIsRepunchModalOpen(true)}
					>
						<Item elevation={3}>
							<CssRepunchSvg />
							<CssTypography>Re Punch</CssTypography>
						</Item>
					</Grid>
					<Grid
						item
						marginTop={4}
						style={{ cursor: 'pointer' }}
						onClick={() => setIsReengraveModalOpen(true)}
					>
						<Item elevation={3}>
							<CssReEngraveSvg />
							<CssTypography>Re Engrave</CssTypography>
						</Item>
					</Grid>
				</Grid>
			</Grid>
			{isReprintModalOpen && (
				<ReprintBarcodeModal
					open={isReprintModalOpen}
					handleClose={() => setIsReprintModalOpen(false)}
				/>
			)}
				{isRepunchModalOpen && (
				<RepunchModal
					open={isReprintModalOpen}
					handleClose={() => setIsRepunchModalOpen(false)}
				/>
			)}
			{isReengraveModalOpen && (
				<ReengraveModal
					open={isReengraveModalOpen}
					handleClose={() => setIsReengraveModalOpen(false)}
				/>
			)}
		</Grid>
	);
};

Sidebar.propTypes = {};

export default Sidebar;
